import { MdShoppingCart, MdWorkHistory } from "react-icons/md";
import { Link, NavLink, Navigate } from "react-router-dom";
import { AiFillNotification } from "react-icons/ai";
import { RiDashboardFill } from "react-icons/ri";
import { FaSignOutAlt } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { useState } from "react";
import { isEmpty } from "lodash";

import ColorChangingIcon from "../../../helpers/ColorChangingIcon/ColorChangingIcon";
import NewsModal from "../../../helpers/NewsModal/NewsModal";
import Logo from "./../../../helpers/Logo/Logo";
import { decodeJWT } from "../../../utils";

const PublicPcMenu = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setOpenModal(false);
  };

  const token = localStorage.getItem("token");
  const isLogin = !isEmpty(token);
  const roleName = decodeJWT(token)?.usertype;

  if (!isLogin) return <Navigate to="/" replace />;

  return (
    <>
      <div
        className="h-screen z-50 fixed p-3 bg-transparent
        lg:flex hidden
        2xl:w-[6%] xl:w-[8%] lg:w-[11%] xl:hover:w-[11%] lg:hover:w-[13%]
        transition-all duration-300 ease-in
        hover:transition-all hover:duration-300 hover:ease-out
        animate__animated animate__fadeInRight animate__faster"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className="w-full h-full flex flex-col items-center 
          justify-between rounded-2xl bg-menuBackground"
        >
          {/* News - Logo - Buttons - Publisher Text */}
          <div className="h-full w-full">
            {/* News - Logo - Buttons */}
            <div
              className={`w-full h-full flex flex-col justify-center items-center pt-4
               ${
                 isHovered
                   ? "animate__animated animate__fadeInRight animate__fast"
                   : "animate__animated animate__fadeIn animate__fast"
               }`}
            >
              {/* Logo */}
              <div className="flex">
                <Logo
                  width={isHovered ? 115 : 65}
                  height={isHovered ? 28 : 16}
                />
              </div>
              <div className="flex flex-col justify-center items-center w-full h-full">
                {/* Buttons */}
                <span className="flex flex-col justify-start h-full">
                  <ul
                    className="space-y-4 flex flex-col justify-center items-center
                     relative tracking-wide mt-10 text-white font-medium text-sm"
                  >
                    {/* 1 */}
                    <li>
                      <NavLink
                        to="/Public/Home"
                        className={({ isActive }) =>
                          isActive
                            ? "flex items-center justify-center rounded-xl cursor-pointer text-slate-50"
                            : "flex items-center justify-center rounded-xl text-slate-400 hover:text-slate-200 cursor-pointer"
                        }
                      >
                        <span
                          className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                        >
                          <IoHome size={30} className="mt-1" />
                          {isHovered && <span className="mt-1">خانه</span>}
                        </span>
                      </NavLink>
                    </li>
                    {/* 2 */}
                    <li>
                      <NavLink
                        to="/Public/Live-Transactions"
                        className={({ isActive }) =>
                          isActive
                            ? "flex items-center justify-center cursor-pointer text-slate-50"
                            : "flex items-center justify-center text-slate-400 hover:text-slate-200 cursor-pointer"
                        }
                      >
                        <span
                          className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                        >
                          <MdShoppingCart size={30} className="mt-1" />
                          {isHovered && (
                            <span className="mt-1">معاملات فعال</span>
                          )}
                        </span>
                      </NavLink>
                    </li>
                    {/* 3 */}
                    <li>
                      <NavLink
                        to="/Public/Last-Transactions"
                        className={({ isActive }) =>
                          isActive
                            ? "flex items-center justify-center cursor-pointer text-slate-50"
                            : "flex items-center justify-center text-slate-400 hover:text-slate-200 cursor-pointer"
                        }
                      >
                        <span
                          className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                        >
                          <MdWorkHistory size={30} className="mt-1" />
                          {isHovered && (
                            <span className="mt-1">تاریخچه معاملات</span>
                          )}
                        </span>
                      </NavLink>
                    </li>
                    {/* 4 */}
                    <li>
                      <NavLink
                        to={
                          roleName === "ADMIN"
                            ? "/Admin/Dashboard/Profile"
                            : "/Customer/Profile"
                        }
                        className="flex items-center justify-center cursor-pointer text-slate-400 hover:text-slate-200"
                      >
                        <span
                          className={`flex flex-col justify-center items-center
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                        >
                          <RiDashboardFill size={30} className="mt-1" />
                          {isHovered && (
                            <span className="mt-1">
                              پنل {roleName === "ADMIN" ? "ادمین" : "کاربر"}
                            </span>
                          )}
                        </span>
                      </NavLink>
                    </li>
                    {/* 5 */}
                    <li>
                      <span
                        onClick={() => setOpenModal(!openModal)}
                        className={`flex flex-col justify-center items-center
                  cursor-pointer text-slate-400 hover:text-slate-200
                      ${
                        isHovered
                          ? "animate__animated animate__fadeInRight animate__fast"
                          : "animate__animated animate__fadeIn animate__fast"
                      }
                    `}
                      >
                        <div>
                          <ColorChangingIcon
                            Icon={AiFillNotification}
                            size={30}
                            firstColor="#ffe700"
                            secondColor="#ffffff"
                          />
                          {isHovered && <span className="mt-1">اخبار</span>}
                          {/* Modal */}
                          <span className="absolute right-28 bottom-10 w-72 z-50">
                            {isHovered && openModal && (
                              <NewsModal openModal={openModal} />
                            )}
                          </span>
                        </div>
                      </span>
                    </li>
                  </ul>
                </span>
                {/* Publisher Text */}
                <span className="flex justify-end h-full">
                  {isHovered && (
                    <div
                      className={`flex justify-center items-end w-full h-full
              ${
                isHovered
                  ? "animate__animated animate__fadeInRight animate__fast"
                  : "animate__animated animate__fadeIn animate__fast"
              }`}
                    >
                      <span className="text-xs text-slate-200 text-center leading-relaxed">
                        طراحی و توسعه توسط
                        <a
                          href="http://nimasaneei.ir/"
                          rel="noreferrer"
                          target="_blank"
                          className="font-medium tracking-wide px-0.5 text-publisher"
                        >
                          NimaSN
                        </a>
                      </span>
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
          {/* Exit Button */}
          <div className="w-full flex justify-center items-center border-t border-gray-600">
            <NavLink to="/Log-Out">
              <button
                className={`px-4 py-3 flex flex-col justify-center items-center 
                rounded-md text-slate-400 hover:text-slate-200
                ${
                  isHovered
                    ? "animate__animated animate__fadeInRight animate__fast"
                    : "animate__animated animate__fadeIn animate__fast"
                }`}
              >
                <FaSignOutAlt size={30} />
                {isHovered && <span>خروج</span>}
              </button>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default PublicPcMenu;
